import { FullscreenTwoStepContent } from '../../components/FullscreenTwoStepContent/index.js';
import { FORM_TYPES } from '../../forms.js';
import { LoginForm } from '../../forms/Login/index.js';
import { RegistrationForm } from '../../forms/Registration/index.js';
import { ResetPasswordForm } from '../../forms/ResetPassword/index.js';
import { TwoStepLoginRegistration } from '../../forms/TwoStepLoginRegistration/index.js';
export const modalFormConfigs = (twoStepModalExperimentVariant) => {
    return [
        {
            component: twoStepModalExperimentVariant === 'B'
                ? TwoStepLoginRegistration
                : LoginForm,
            type: FORM_TYPES.LOGIN,
        },
        {
            component: TwoStepLoginRegistration,
            type: FORM_TYPES.BASIC_TWO_STEP,
        },
        {
            component: twoStepModalExperimentVariant === 'B'
                ? TwoStepLoginRegistration
                : RegistrationForm,
            type: FORM_TYPES.REGISTRATION,
        },
        {
            component: ResetPasswordForm,
            type: FORM_TYPES.RESET_PASSWORD,
        },
        {
            component: FullscreenTwoStepContent,
            type: FORM_TYPES.FULLSCREEN_TWO_STEP,
            fullscreenModal: true,
        },
    ];
};
//# sourceMappingURL=modalFormConfigs.js.map